export default __webpack_public_path__ + "static/media/home-banner.8f942076.jpg";